'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ServiceAccountStore = require('../stores/ServiceAccountStore'),
    UserStore = require('../stores/UserStore'),
    Button = require('../atoms/Button'),
    Link = require('../atoms/Link'),
    UserActionCreators = require('../actions/UserActionCreators'),
    FormLink = require('../utils/FormLink'),
    getServiceName = require('../utils/getServiceName'),
    getServiceAccountUrl = require('../utils/getServiceAccountUrl'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./ServiceAccountRow.less');

var ServiceAccountRow = React.createClass({
  mixins: [createStoreMixin(ServiceAccountStore), PureRenderMixin],

  propTypes: {
    serviceType: React.PropTypes.string.isRequired,
    allowDisconnect: React.PropTypes.bool.isRequired,
    formLink: React.PropTypes.instanceOf(FormLink).isRequired
  },

  getStateFromStores() {
    return {
      serviceAccount: ServiceAccountStore.getByType(UserStore.getMe().id, this.props.serviceType)
    };
  },

  render: function () {
    return (
      <div className='ServiceAccountRow'>
        <div className='ServiceAccountRow-label'>
          {getServiceName(this.props.serviceType)}
        </div>

        {ServiceAccountStore.isConnected(UserStore.getMe().id, this.props.serviceType) ?
          this.renderConnectedRow() :
          this.renderDisconnectedRow()
        }
      </div>
    );
  },

  renderConnectedRow: function () {
    var serviceAccount = this.state.serviceAccount,
        hidden = serviceAccount && serviceAccount.hidden,
        externalName = serviceAccount && serviceAccount.externalName,
        externalLink = serviceAccount && getServiceAccountUrl(serviceAccount);

    return (
      <div className='ServiceAccountRow-body'>
        {this.props.allowDisconnect &&
          <Link className='utils--floatRight'
                color='gray'
                onClick={this.handleDisconnectClick}>
            Disconnect
          </Link>
        }

        <Link className='ServiceAccountRow-name'
              target='_blank'
              href={externalLink}
              bold>
          {externalName}
        </Link>

        <div className='ServiceAccountRow-toggle'>
          <Button onClick={this.handleShowClick}
                  active={!hidden}
                  switch />

          <span className='ServiceAccountRow-toggleLabel'>
            {hidden ?
              'Don’t show in profile' :
              'Show in profile'
            }
          </span>
        </div>
      </div>
    );
  },

  renderDisconnectedRow: function () {
    var errorMessage = this.props.formLink.fieldMessage;

    return (
      <div className='ServiceAccountRow-body'>
        <Link onClick={this.handleConnectClick}
              color='green'
              bold>
          Connect
        </Link>

        {errorMessage &&
          <div className='ServiceAccountRow-error'>
            {errorMessage}
          </div>
        }
      </div>
    );
  },

  handleShowClick: function () {
    var hidden = this.state.serviceAccount.hidden;
    UserActionCreators.toggleServiceAccountHidden(this.props.serviceType, !hidden);
  },

  handleConnectClick: function () {
    UserActionCreators.connectServiceAccount(this.props.serviceType);
  },

  handleDisconnectClick: function () {
    UserActionCreators.disconnectServiceAccount(this.props.serviceType);
  }
});

module.exports = ServiceAccountRow;



/** WEBPACK FOOTER **
 ** ./molecules/ServiceAccountRow.jsx
 **/